// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/PlatformLinks/index.css
// module id = 2564
// module chunks = 0